// removed by extract-text-webpack-plugin
module.exports = {"form":"_1TS4iTPEFS38knWcUwV1ja"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AddContact/AddContactSuggestForm/AddContactSuggestForm.scss
// module id = 1237
// module chunks = 1